module.exports = __webpack_public_path__ + "static/img/ragonvr.b84bae2c.png";